import { useState, useEffect } from 'react'
import { lumi } from '@/lib/lumi'

export function useAuth() {
  const [user, setUser] = useState<any>(null)
  const [loading, setLoading] = useState(true)

  const enrichUserWithRole = async (authUser: any) => {
    if (!authUser) return null
    
    try {
      // Fetch player data to get userRole
      const playerResult = await lumi.entities.players.list({
        filter: { userId: authUser.userId },
        limit: 1
      })
      
      if (playerResult?.list?.[0]) {
        return { ...authUser, userRole: playerResult.list[0].userRole }
      }
    } catch (error: any) {
      const errorMessage = error?.data?.error || error?.message || 'Unknown error'
      console.error('Failed to fetch user role:', errorMessage, error)
    }
    
    return authUser
  }

  useEffect(() => {
    const checkAuth = async () => {
      try {
        if (lumi.auth.isAuthenticated) {
          const currentUser = await lumi.auth.refreshUser()
          const enrichedUser = await enrichUserWithRole(currentUser)
          setUser(enrichedUser)
        }
      } catch (error) {
        console.error('Auth check failed:', error)
        setUser(null)
      } finally {
        setLoading(false)
      }
    }

    checkAuth()

    const unsubscribe = lumi.auth.onAuthChange(async (newUser) => {
      const enrichedUser = await enrichUserWithRole(newUser)
      setUser(enrichedUser)
    })

    return () => unsubscribe()
  }, [])

  const signOut = () => {
    lumi.auth.signOut()
    setUser(null)
  }

  return { user, loading, signOut }
}
